module.exports = __webpack_public_path__ + "static/media/desk-min.c3ca82a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/desk-min.jpg
// module id = 48
// module chunks = 0